import React, { useEffect, useState } from 'react';
import ESA_LOGO from './assets/ESA_LOGO.png';
import ASC_LOGO from './assets/ASC_LOGO.png';
import ESC_LOGO from './assets/ESC_LOGO.png';
import ASA_PMS from './assets/ASA PMS 300.png';
import { getAllCompanies } from 'Root/Libs/http';

import sydney_app from './assets/sydney App.png';
import virtual_care from './assets/Virtual Care.png';
import Nurseline from './assets/Nurseline.png';
import Mental_Health from './assets/Mental Health.png';
import Travel_benifit from './assets/Travel Benefits.png';
import Chat from './assets/Chat.png';
import Video2 from './assets/Video2.png';
import Video3 from './assets/Video3.png';
import styled from 'styled-components';
import { Container } from 'Components/core';
import CustomFonts from 'Root/fonts/CustomFonts';
import additonalSchools from 'Views/ErrorPage/AdditionalSchools';
import gtag, { install } from 'ga-gtag';

const select = 'Select a school';


const SelectHolder = styled.div`
  @media (max-width: 400px) {
    margin: 0px;
  }
`;

const AContainer = styled(Container)`
  @media (max-width: 820px) {
    padding: 16px;
  }
`;

const Image = styled.img`
  width: auto;
`;

const PanelHolder = styled.div`
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;
  justify-content: center;
`;

const ViewButton = styled.button`
  background: #0079c2;
  font-family: Kievit OT;
  font-weight: 500;
  font-size: 18px;
  text-align: left;
  color: #ffffff;
  cursor: pointer;
  margin-left: 20px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  opacity: 1;
`;

const Video = styled.video`
  position: absolute;
  z-index: 1;
  min-width: 100%;
  @media (max-width: 820px) {
    position: static;
  }
`;

const VideoThumbHolder = styled.div`
  display: flex;
  background-color: rgba(105, 179, 231, 0.15);
  padding-left: 150px;
  padding-right: 150px;
  justify-content: space-between;
  padding-top: 35px;
  padding-bottom: 35px;

  @media (max-width: 820px) {
    padding-left: 10px;
    padding-right: 0px;
    margin-right: -16px;
    margin-left: -32px;
    flex-wrap: wrap;
  }
`;

const VideoHolder = styled.div`
  position: relative;
  min-height: 640px;
  @media (max-width: 1000px) {
    min-height: 550px;
  }

  @media (max-width: 820px) {
    position: static;
    min-height: auto;
  }
`;

const LeftPanel = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: 820px) {
    position: static;
  }
`;

const WhitePanel = styled.div`
  background-color: #ffffff;

  max-width: 600px;
  opacity: 0.8;
  padding: 50px;
  @media (max-width: 820px) {
    max-width: 100%;
    padding: 10px;
    margin-top: 10px;
  }
`;

const MainHighLight = styled.span`
  font-family: Kievit OT;
  font-weight: 900;
  font-size: 46px;

  color: #0879c2;
`;

const MainText = styled.span`
  color: #092a6d;
  font-weight: 900;
  font-size: 46px;
  font-family: Kievit OT;
`;

const MainTitle1 = styled.div`
  font-family: Kievit OT;
  font-size: 24px;
  color: #092a6d;
`;

const MainTitle2 = styled.div`
  font-family: Kievit OT;
  font-weight: Medium;
  font-size: 18px;
  color: #707070;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const WelcomeText = styled.div`
  font-family: Kievit OT;
  font-weight: normal;
  font-size: 24px;
  text-align: left;
  color: #0079c2;
  margin-bottom: 20px;
`;

const PanelText = styled.div`
  font-family: Kievit OT;
  font-weight: bold;
  font-size: 16px;
  text-align: left;
  color: #707070;
`;

const APanel = ({ text, image, align, style }) => {
  return (
    <div
      style={{
        margin: 3,
        ...style,
        flex: 1,
        display: 'flex',
        marginBottom: 20,
        alignItems: 'center',

        justifyContent: align
      }}
    >
      <Image src={image} style={{ marginRight: 10 }}></Image>
      <PanelText dangerouslySetInnerHTML={{ __html: text }}></PanelText>
    </div>
  );
};

const AVideoHeader = styled.div`
  font-family: Kievit OT;
  font-weight: 500;
  font-size: 18px;
  text-align: left;
  color: #0079c2;
  margin-bottom: 10px;
`;

const AVideoText = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: Kievit OT;
  font-weight: normal;
  font-size: 16px;
  text-align: left;
  color: #707070;
`;

const AVideoLink = styled.a`
  font-family: Kievit OT;
  font-weight: bold;
  text-decoration: underline;
  font-size: 16px;
  text-align: left;
  color: #027dbf;
  margin-right: 5px;
`;

const FooterText = styled.div`
  font-family: Kievit OT;
  font-weight: normal;
  font-size: 10px;
  text-align: left;
  color: #707070;
`;

const MainPanelHolder = styled.div`
  margin-left: 140px;
  margin-right: 140px;

  @media (max-width: 820px) {
    margin: 20px;
  }
`;

const AVideoHolder = styled.div`
  max-width: 322px;

  @media (max-width: 820px) {
    margin-left: 14px;
    margin-top: 20px;
  }
`;

const AVideo = ({ text, linkText, link, header, thumbnail, onClick }) => {
  return (
    <AVideoHolder>
      <AVideoHeader>{header}</AVideoHeader>
      <div style={{ width: '100%' }}>
        <AVideoLink target={'_blank'} href={link}>
          <Image src={thumbnail} />
        </AVideoLink>
      </div>
      <div>
        <AVideoText>{text}</AVideoText>
      </div>
      <div>
        <AVideoLink target={'_blank'} onClick={onClick} href={link}>
          {linkText}
        </AVideoLink>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="10"
          viewBox="0 0 9 10"
        >
          <g
            id="Polygon_5"
            data-name="Polygon 5"
            transform="translate(9) rotate(90)"
            fill="none"
          >
            <path d="M5,0l5,9H0Z" stroke="none" />
            <path
              d="M 5 2.059127807617188 L 1.699515342712402 8 L 8.300484657287598 8 L 5 2.059127807617188 M 5 0 L 10 9 L 0 9 L 5 0 Z"
              stroke="none"
              fill="#0879c2"
            />
          </g>
        </svg>
      </div>
    </AVideoHolder>
  );
};
////  const BRANDS= ['ABC','ABCBS','EBC','BCBS'];
export default ({ brand ,path }) => {
  const mappings = {
    ABC: {
      image: ASC_LOGO,
      name: 'Anthem BC',
      welcome_name: 'Anthem',
      brand: 'ABC',
      legal: (
        <p>
          Independent licensee of the Blue Cross Association. Read more{' '}
          <a href="https://www.anthem.com/ca/about/"> about us</a>.
        </p>
      ),
      video_care: ' https://bcove.video/3Sjc1zb',
      video_all: 'https://bcove.video/3v6k75R',
      projectNumber: '1044161CAMENASC BV 08/22',
      link: 'https://www.anthem.com/ca/about/'
    },
    ABCBS: {
      image: ASA_PMS,
      name: 'Anthem BCBS',
      welcome_name: 'Anthem',
      brand: 'ABS',
      legal: (
        <p>
          Independent licensee of the Blue Cross Blue Shield Association. Read
          more <a href="https://www.anthem.com/about/"> about us</a>.
        </p>
      ),
      video_care: 'https://bcove.video/3BOFRF3',
      video_all: 'https://bcove.video/3v6k75R',
      projectNumber: '1044161MUMENASA BV 08/22',
      link: 'https://www.anthem.com/about/'
    },
    BCBS: {
      image: ESA_LOGO,
      name: 'Empire',
      welcome_name: 'Empire',
      brand: 'EBS',
      legal: (
        <p>
          Independent licensee of the Blue Cross Blue Shield Association, an
          association of independent Blue Cross and Blue Shield plans. Read more
          <a href="https://www.empireblue.com/about/"> about us</a>.
        </p>
      ),
      video_care: 'https://bcove.video/3LP7WAw',
      video_all: 'https://bcove.video/3v6k75R',
      projectNumber: '1044161NYMENESA BV 08/22',
      link: 'https://www.empireblue.com/about/'
    },
    EBC: {
      image: ESC_LOGO,
      name: 'Empire BC',
      welcome_name: 'Empire',
      brand: 'EBC',
      legal: (
        <p>
          Independent licensee of the Blue Cross Association, an association of
          independent Blue Cross and Blue Shield plans. Read more{' '}
          <a href="https://www.empireblue.com/about/"> about us</a>.
        </p>
      ),
      video_care: 'https://bcove.video/3cvLnAU',
      video_all: 'https://bcove.video/3v6k75R',
      projectNumber: '1044161NYMENESC BV 08/22',
      link: 'https://www.empireblue.com/about/'
    }
  };

  const [schools, setSchools] = useState([]);
  const [selectedId, setSelectedId] = useState(select);

  const info = mappings[brand];
  const unknownValueforU1 = document.URL;
  //`https://www.studentsatanthem.com${path}?utm_source=fb&utm_medium=SOC&utm_campaign=Student+Adv`;

  useEffect(() => {
    document.title = `${mappings[brand].brand} | Landing`;
    getAllCompanies().then(({ companies }) => {
      // debugger;
      let schools = companies
        .sort((a, b) => {
          return a.id.localeCompare(b.id);
        })
        .filter(a => a.published_date && a.brand.includes(info.name));
      setSchools(schools);
    });
    install('DC-11619105');

    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      u1: unknownValueforU1,
      send_to: 'DC-11619105/pagel0/kpi_c00+standard'
    });
  }, []);

  const buttonPress = () => {

if(selectedId==select)
{
return;
}

    let go = '';
    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      u1: unknownValueforU1,
      send_to: 'DC-11619105/butto0/kpi_c014+standard'
    });
    if (selectedId.indexOf('http') === 0) {
      go = selectedId;
   
    } else  if (selectedId != select) {
     
      go = `/?id=${selectedId}`;
    }
    setTimeout(() => {
      location.replace( go );
    }, 500);
  };

  return (
    <AContainer
      seperation="32px"
      column
      maxWidth
      style={{
        margin: 'auto',
        padding: '32px',
        paddingRight: 0,
        paddingLeft: 0
      }}
    >
      <CustomFonts />
      <div>
        <Image src={info.image} />
      </div>

      <VideoHolder>
        <Video
          style={{ width: '100%' }}
          autoPlay={true}
          muted={true}
          loop={true}
        >
          <source
            src="https://studentsatanthem.com/video/Hero%20flip_v3_SkateBoarder_GettyImages-852456216.mp4"
            type="video/mp4"
          />
        </Video>

        <LeftPanel>
          <WhitePanel>
            <div>
              <MainHighLight>Healthcare </MainHighLight>
              <MainText>made easy.</MainText>{' '}
            </div>
            <MainTitle1>For students, that's a game-changer.</MainTitle1>
            <MainTitle2>
              When students are in college, healthcare may be the last thing on
              their mind. We’re good with that.{' '}
            </MainTitle2>

            <div>
              <SelectHolder
                style={{
                  marginTop: 20,
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
               
                <select
                  value={selectedId}
                  onChange={e => {
                    setSelectedId(e.target.value);
                    /*
                    remove this .. ?
                    gtag('event', 'conversion', {
                      allow_custom_scripts: true,
                      u1: unknownValueforU1,
                      send_to: 'DC-11619105/butto0/kpi_c014+standard'
                    });
                    */
                  }}
                  style={{ width: '100%', flex: 1 }}
                >
                  <optgroup label="School Sites">
                    <option>{select}</option>
                    {schools.map(school => (
                      <option value={school.id} key={school.id}>
                        {school.id}
                      </option>
                    ))}
                  </optgroup>
                  <optgroup label="Additional School Sites">
                    {additonalSchools.map(school => (
                      <option value={school[1]} key={school[1]}>
                        {school[0]}
                      </option>
                    ))}
                  </optgroup>
                </select>
                <ViewButton
                  onClick={() => {
                    buttonPress();
                  }}
                >
                  View school benefits
                </ViewButton>
              </SelectHolder>
            </div>
          </WhitePanel>
        </LeftPanel>
      </VideoHolder>

      <MainPanelHolder>
        <WelcomeText>
          Welcome to {info.welcome_name} Student Advantage, featuring:
        </WelcomeText>
        <PanelHolder>
          <APanel text={'Sydney&#x2120; Health app'} image={sydney_app} />
          <APanel text={'Virtual care'} image={virtual_care} align="center" />

          <APanel
            text={'24/7 NurseLine'}
            image={Nurseline}
            align="flex-end"
            style={{ paddingRight: 5 }}
          />
        </PanelHolder>
        <PanelHolder>
          <APanel text={'Mental health coverage'} image={Mental_Health} />

          <APanel
            text={'Travel benefits'}
            image={Travel_benifit}
            style={{ paddingLeft: 10 }}
            align="center"
          />
          <APanel text={'Support by chat'} image={Chat} align="flex-end" />
        </PanelHolder>
      </MainPanelHolder>
      <VideoThumbHolder>
        <AVideo
          onClick={() => {
            gtag('event', 'conversion', {
              allow_custom_scripts: true,
              u1: unknownValueforU1,
              send_to: 'DC-11619105/linkf0/csbd_00d+standard'
            });
          }}
          text={
            'We’re transforming the way students think about and manage their care with clear information, easy app navigation, and endless support.'
          }
          link={info.video_care}
          linkText={'Take the tour'}
          header="Care from anywhere"
          thumbnail={Video2}
        />

        <AVideo
          onClick={() => {
            gtag('event', 'conversion', {
              allow_custom_scripts: true,
              u1: unknownValueforU1,
              send_to: 'DC-11619105/linkf0/csbd_00e+standard'
            });
          }}
          text={
            'With our Sydney Health app, students can check benefits, chat with a doctor, see mental health professionals, and more, right from their phone. '
          }
          link={info.video_all}
          linkText={'See how now'}
          header="Our app is everything"
          thumbnail={Video3}
        />
      </VideoThumbHolder>
      <div style={{ marginLeft: 20, marginRight: 20 }}>
        <div style={{ marginBottom: 10 }}>
          <Image src={info.image} />
        </div>
        <FooterText>
          <p>
            In addition to using a telehealth service, you can receive in-person
            or virtual care from your own doctor or another healthcare
            professional in your plan’s network. If you receive care from a
            doctor or healthcare professional not in your plan’s network, your
            share of the costs may be higher. You may also receive a bill for
            any charges not covered by your health plan.
          </p>
          <p>
            Sydney Health is offered through an arrangement with Carelon Digital
            Platforms, a separate company offering mobile application services
            on behalf of your health plan. ©2020-2022 The Virtual Primary Care
            experience is offered through an arrangement with Hydrogen Health.
          </p>
          {info.legal} {info.projectNumber}
        </FooterText>
      </div>
    </AContainer>
  );
};
